import React, { Component } from 'react';
import Input from '../../../components/Input/input.component';
import SelectMulti from '../../../components/SelectMulti/selectmulti.component';
import BuscaAvancada, { BuscaAvancadaContext } from '../../../components/BuscaAvancada/buscaAvancada.component';

export default class PesquisaAvancadaOficio extends Component {
	state = {
		filtro: {
			nomeEntidade: '',
			municipiosSelecionados: [],
			statusSelecionados: [],
			dataInicial: undefined,
			dataFinal: undefined,
			simplificado: false,
			ordem: undefined,
			ordemDirecao: undefined,
		},
	}

	/*
		Tratamento para limpar as datas quando o usuário apagar os valores manualmente
		a fim de não enviar uma String vazia onde o back-end espera um objeto do tipo Date
		e para enviar apenas os ids dos municípios e status selecionados

	*/

	adjustMunicipiosFilter = (resultFilter) => {
		const newResult = {};

		Object.assign(newResult, resultFilter);

		newResult.municipiosSelecionados = resultFilter.municipiosSelecionados.map(item => item.value);

		newResult.statusSelecionados = resultFilter.statusSelecionados.map(item => item.value);

		newResult.dataInicial = newResult.dataInicial === '' ? undefined : newResult.dataInicial;

		newResult.dataFinal = newResult.dataFinal === '' ? undefined : newResult.dataFinal;

		return newResult;
	}

	render() {
		const {
			props: {
				municipios, handlePesquisaSimplificada, serviceSearch, statusOficio, resetIconOrder,
			},
			state: {
				filtro,
			},
		} = this;
		return (
			<BuscaAvancada
				initialValues={filtro}
				handleSearch={(resultFilter) => {
					const filteredResultFilter = this.adjustMunicipiosFilter(resultFilter);
					serviceSearch(filteredResultFilter);
				}}
				handleClear={({ resetForm }) => {
					resetForm();
					resetIconOrder();
					filtro.isClearable = true;
					serviceSearch(filtro);
				}}
				handlePesquisaSimplificada={handlePesquisaSimplificada}
			>
				<BuscaAvancadaContext.Consumer>
					{({
						values,
						handleChange,
						setFieldValue,
					}) => (
						<React.Fragment>
							<div className='row mb-2'>
								<div className='col-6'>
									<label>Entidade</label>
									<Input
										type='text'
										name='nomeEntidade'
										value={values.nomeEntidade}
										maxLength='255'
										onChange={handleChange}
									/>
								</div> {/* col-6 */}

								<div className='col-6'>
									<label>Município</label>
									<SelectMulti
										isMulti
										isClearable
										name='municipiosSelecionados'
										uniqueKey='codigoIbge'
										label='nome'
										value={values.municipiosSelecionados || []}
										onChange={(value) => {
											handleChange(value);
											setFieldValue('municipiosSelecionados', value);
										}}
										options={municipios}
									/>
								</div> {/* col-6 */}
							</div> {/* row mb-1 */}

							<div className='row d-flex align-items-end'>
								<div className='col-6 mb-2'>
									<label>Status</label>
									<SelectMulti
										isMulti
										isClearable
										name='statusSelecionados'
										uniqueKey='id'
										label='nome'
										value={values.statusSelecionados || []}
										onChange={(value) => {
											handleChange(value);
											setFieldValue('statusSelecionados', value);
										}}
										options={statusOficio}
									/>
								</div> {/* col-6 */}

								<div className='col-6 d-flex align-items-end'>

									<div className='col-6 pl-0'>
										<label>Data inicial de recebimento</label>
										<Input
											type='date'
											name='dataInicial'
											value={values.dataInicial || ''}
											onChange={handleChange}
											max={values.dataFinal ? values.dataFinal : undefined}
										/>
									</div>

									<div className='col-6 pr-0'>
										<label>Data final de recebimento</label>
										<Input
											type='date'
											name='dataFinal'
											value={values.dataFinal || ''}
											onChange={handleChange}
											min={values.dataInicial ? values.dataInicial : undefined}
										/>
									</div>
								</div> {/* col-6 */}
							</div> {/* row */}
						</React.Fragment>
					)}
				</BuscaAvancadaContext.Consumer>
			</BuscaAvancada>
		);
	}
}
